import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import AppContainer from "../AppContainer/AppContainer";
import { getPending, finalise } from "../../apiPromises/jobsApi";

import "./quality-check.scss";
import { useTranslation } from "react-i18next";

const ProcessorQualityCheck = props => {

    const [rejectionReason, setRejectionReason] = useState("");
    const [logs, setLogs] = useState([]);
    const [selectedLog, setSelectedLog] = useState({
        CollectionLogId: 0,
        CollectionSiteId: 0,
        JobId: 0,
        PlasticAmount: 0,
        PlasticType: ""
    });
    const [t] = useTranslation();

    function changeReason(e) {
        switch (parseInt(e.target.value)) {
            case 0:
                setRejectionReason("Not the right plastic");
                break;
            case 1:
                setRejectionReason("Bag contains other");
                break;
            case 2:
                setRejectionReason("Plastic contaminated");
                break;
            case 3:
                setRejectionReason("Wrong weight");
                break;
            case 4:
                setRejectionReason("Other");
                break;
            default:
                break;
        }
    }

    function dropdownSelected(e) {
        for (let i = 0; i < logs.length; i++) {
            if (logs[i].CollectionLogId === parseInt(e.target.value)) {
                setSelectedLog(logs[i]);
            }
        }
    }

    function reject() {
        popToast(selectedLog.CollectionLogId, false);
        finalise(selectedLog.CollectionLogId, false, rejectionReason);
    }

    function accept() {
        popToast(selectedLog.CollectionLogId, true);
        finalise(selectedLog.CollectionLogId, true);
    }

    function popToast(id, resultStatus) {
        const confirmElement = document.createElement("div");
        confirmElement.append(document.createTextNode("Job " + id + " " + (resultStatus ? "accepted" : "rejected.")));
        confirmElement.classList.add("confirmMessage");
        confirmElement.classList.add(resultStatus ? "accepted" : "rejected");
        setTimeout(() => { confirmElement.classList.add("visible") }, 50);
        setTimeout(() => { confirmElement.classList.remove("visible") }, 4500);
        setTimeout(() => {
            document.body.removeChild(confirmElement);
        }, 5000);

        document.body.appendChild(confirmElement);
    }

    async function getPendingLogs() {
        getPending().then((res) => setLogs(res.data));
    }

    useEffect(() => {
        getPendingLogs();
    }, []);

    return (
        <AppContainer>
            <div className="formContainer">
                <div className="formObject withBorder centred title">{t("processor")}</div>
                <div className="formObject withBorder column">
                    Collection ID: <select id="finalLogSelect" onChange={dropdownSelected}>
                        <option disabled selected hidden>Select a collection</option>
                        {logs.map(log =>
                            <option
                                key={log.CollectionLogId}
                                name={log.CollectionLogId}
                                value={log.CollectionLogId}>
                                {log.CollectionLogId}
                            </option>)}
                    </select>
                    <div className="subObject">From: HUB #{selectedLog.CollectionSiteId}</div>
                    <div className="subObject">{t("jobNum")}{selectedLog.JobId}</div>
                    <div className="subObject">CONTENTS: {selectedLog.PlasticAmount} {t("kg")} {selectedLog.PlasticType}</div>
                </div>
                <div className="formObject centred withBorder accept" onClick={accept}>{t("accept")}</div>
                <div className={"formObject centred withBorder " + (rejectionReason ? "reject" : "disabled")} onClick={reject}>{t("reject")}</div>
                <div className="formObject dropdown">
                    <div className="label">{t("reasonForRejection")}</div>
                    <select onChange={changeReason}>
                        <option disabled selected hidden value>Select a reason</option>
                        <option value="0">Not the right plastic</option>
                        <option value="1">Bag contains other</option>
                        <option value="2">Plastic contaminated</option>
                        <option value="3">Wrong weight</option>
                        <option value="4">Other</option>
                    </select>
                </div>
            </div>
        </AppContainer>
    );
}

export default withRouter(ProcessorQualityCheck);